export default __webpack_public_path__ + "svTransBannerBg.95756c08670944101db1c32fccaecc52.png";